export const ActionType = {
  SET_TOAST: "SET_TOAST",
  REMOVE_TOAST: "REMOVE_TOAST",
};

export interface ToastMessage {
  msg: string;
  link: string;
  messageId: string;
  method?: string;
}

export interface NotificationSettings {
  status: false;
  msg: ToastMessage[];
  messageId: string | null;
}
